export const PRIVACY_POLICY_FLUFFY_URL = 'https://www.joinfluffy.com/privacy-policy';
export const PRIVACY_POLICY_CM_URL = 'https://www.blueinsurance.ie/PrivacyPolicy/UK/';
export const MIN_VET_COVER_PRODUCT_INFORMATION_URL =
  'https://66917634-707b-4588-b42f-3fd372266745.filesusr.com/ugd/d12467_fea37a57ce2748e88758307e85e9070b.pdf';
export const MID_VET_COVER_PRODUCT_INFORMATION_URL =
  'https://66917634-707b-4588-b42f-3fd372266745.filesusr.com/ugd/d12467_0c0bac3dfedf4c83b404b855e147d237.pdf';
export const MAX_VET_COVER_PRODUCT_INFORMATION_URL =
  'https://66917634-707b-4588-b42f-3fd372266745.filesusr.com/ugd/d12467_f707bade29044877b14cf8e8a7135831.pdf';
export const TERMS_OF_BUSINESS_URL = 'https://www.insureyourpaws.co.uk/Documents/Toba';
export const POLICY_DOCUMENT_STATEMENTS_URL =
  'https://66917634-707b-4588-b42f-3fd372266745.filesusr.com/ugd/d12467_59ef8c5c206e42dc99f2b4ffb2a869fe.pdf';
export const INSURANCE_ASSUMPTIONS_URL = 'https://www.joinfluffy.com/insurance-assumptions';
